































































































































































































































































import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Ajax from "@/lib/ajax";
import RegionSelect from "@/components/region-select.vue";
import Order from "@/store/entities/booking/order";
import OrderDetail from "./components/order-detail.vue";
import TabsHeader from "@/components/tabs-header.vue";
import moment from "moment";
import UpdateTravel from "@/components/update-travel.vue";
import OrderTravelDate from "@/components/OrderTravelDate.vue";
import appConsts from "@/lib/appconst";
import CreateOrder from "./components/create-order.vue";
import appconst from "@/lib/appconst";
import UpdateOrderInRefund from "./components/updateOrderInRefund.vue";
import SeletedPayee from "./components/seleted-payee.vue";
class PageOrderRequest extends PageRequest {
  orderType: number = null;
  orderNum: string;
  startDate: Date = null;
  endDate: Date = null;
  orderState: number = null;
  phoneNumber: number = null;
  sourceType: number = null;
  orderSource: number = 0;
  personNameOrLinkMan: string | null = null;
}

@Component({
  components: {
    RegionSelect,
    OrderDetail,
    TabsHeader,
    UpdateTravel,
    OrderTravelDate,
    CreateOrder,
    UpdateOrderInRefund,
    SeletedPayee,
  },
})
export default class Orders extends AbpBase {
  //filters
  pagerequest: PageOrderRequest = new PageOrderRequest();
  courtList: any = [];
  orderDetail: Order = new Order();
  seletedList: Array<number> = [];
  showOrderDetailModal = false;
  showUpdateTravel: boolean = false;
  showUpdateDateModel: boolean = false;
  editIndex: number = -1;
  editOrderState: number = -1;
  orderId: number = 0;
  editPriceIndex: number = -1;
  isUpdateShow: boolean = false;
  price: any = "";
  showCreateOrder: boolean = false;
  showSeletedPayee: boolean = false;
  showRefundModal: boolean = false; //是否打开部分退款弹出
  sourceTypeList: Array<object> = [
    {
      value: 0,
      label: "小程序",
    },
    {
      value: 1,
      label: "Pc",
    },
    {
      value: 2,
      label: "App",
    },
    {
      value: 3,
      label: "H5",
    },
  ];
  orderSources: Array<object> = [
    {
      value: 0,
      label: "线上",
    },
    {
      value: 1,
      label: "线下",
    },
  ];
  async getCourtList(name?: String) {
    let params = {};
    if (name && name.length > 0) {
      params["name"] = name;
    }
    let reponse = await Ajax.get("/api/services/app/Court/GetAllCourtNames", {
      params,
    });
    this.courtList = reponse.data.result;
  }
  handleEdit(row, index) {
    this.editOrderState = row.orderState;
    this.editIndex = index;
  }
  async add() {
    this.showCreateOrder = true;
  }
  async handCancelAll() {
    this.seletedList = [];
  }
  async openTravelModel(id) {
    if (id) {
      this.orderId = id;
      this.showUpdateTravel = true;
    }
  }
  async exportOrder() {
    try {
      let res = await this.$store.dispatch({
        type: "order/exportOrder",
      });
      if (res && res.data && res.data.result) {
        let url = `${appconst.remoteServiceBaseUrl}${res.data.result}`;
        window.open(url, "_blank");
      }
    } catch (error) {
      console.error("导出 Excel 失败:", error);
    }
  }
  rowClick(order) {
    this.showDetail(order);
  }
  openSeletedPayee(id) {
    this.orderId = id;
    this.showSeletedPayee = true;
  }
  menuClick(name, row, index) {
    switch (name) {
      case "save":
        this.handleSave(row, index);
        break;
      case "cancel":
        this.editIndex = -1;
        break;
      case "detail":
        this.showDetail(row);
        break;
      case "onlineToOffline":
        console.log("success");
        this.openSeletedPayee(row.id);
        // this.onlineToOffline(row.id);
        break;
      case "updateOrderInRefund":
        this.openRefundModal(row.id);
        break;
      case "updateOrderState":
        this.handleEdit(row, index);
        break;
      // case "send":
      //   this.sendToUser(row.id);
      //   break;
      case "createPayUrl":
        this.orderDetail = row;
        this.createPayUrl(row.id);
        break;
      case "updatePrice":
        this.editPriceIndex = index;
        this.isUpdateShow = !this.isUpdateShow;
        if (!this.isUpdateShow) {
          this.updatePrice(row.id);
        }
        break;
      case "sendSmsToUserPay":
        this.sendSmsToUserPay(row.id);
        break;
      case "updateDate":
        this.openUpdateDateModel(row.id);
        break;
      default:
        break;
    }
  }
  openRefundModal(id) {
    if (id) {
      this.orderId = id;
      this.showRefundModal = true;
    }
  }
  async openUpdateDateModel(orderId) {
    this.orderId = orderId;
    this.showUpdateDateModel = true;
  }
  /**
   * @description:生成支付链接
   */
  createPayUrl(orderId) {
    console.log(this.orderDetail, "orderDetail");
    const url = `${appConsts.h5PayUrl}${orderId}`;
    const content = `${this.orderDetail.name}
${moment(this.orderDetail.teeTime).format(
      "YYYY-MM-DD HH:mm:ss"
    )} (${this.getWeekName(this.orderDetail.teeTime)})
${this.orderDetail.personNames} ${this.orderDetail.personCount}位

需支付: ${this.orderDetail.weixinPay}元

支付链接: ${url}`;
    const contentCopy = `
        <div style="font-size: 16px; text-align: left;">
            <p>${this.orderDetail.name}</p>
            <p>${moment(this.orderDetail.teeTime).format(
              "YYYY-MM-DD HH:mm:ss"
            )} (${this.getWeekName(this.orderDetail.teeTime)})</p>
            <p>${this.orderDetail.personNames} ${
      this.orderDetail.personCount
    }位</p>
            <p>&nbsp;</p>
            <p>需支付: ${this.orderDetail.weixinPay}元</p>
            <p>&nbsp;</p>
            <p>支付链接: <a href="${url}" target="_blank">${url}</a></p>
        </div>
    `;

    this.$Modal.success({
      title: "支付链接",
      content: contentCopy,
      okText: "复制",
      width: 750,
      onOk: async () => {
        try {
          await (navigator as any).clipboard.writeText(content);
          this.$Message.success("复制成功");
        } catch (err) {
          this.$Message.error("复制失败");
        }
      },
    });
  }
  getWeekName(date) {
    // 参数时间戳
    let week = moment(date).day();
    switch (week) {
      case 1:
        return "周一";
      case 2:
        return "周二";
      case 3:
        return "周三";
      case 4:
        return "周四";
      case 5:
        return "周五";
      case 6:
        return "周六";
      case 0:
        return "周日";
    }
  }
  async onlineToOffline(id) {
    await this.$store.dispatch({
      type: "order/onlineToOffline",
      id: id,
    });
    this.$Message.success({
      content: "转到线下订单成功",
    });
    await this.getpage();
  }

  async sendSmsToUserPay(id) {
    this.$store
      .dispatch({
        type: "order/sendSmsToUserPay",
        id: id,
      })
      .then((res) => {
        this.$Message.success({
          content: "发送短信成功",
        });
      });
  }
  /**
   * @description:修改旅游打球价格
   */
  async updatePrice(id) {
    await Ajax.put("/api/services/app/Order/UpdatePayPrice", {
      id,
      price: this.price,
    });
    this.$Message.success({
      content: "修改旅游打球价格成功",
    });
    await this.getpage();
  }
  async handleSave(row, index) {
    await Ajax.put("/api/services/app/Order/UpdateOrderState", {
      id: row.id,
      orderState: this.editOrderState,
    });
    row.orderState = this.editOrderState;
    this.editIndex = -1;
    this.editOrderState = -1;
    await this.getpage();
  }

  // 显示订单详情
  showDetail(order) {
    this.orderDetail = order;
    this.showOrderDetailModal = true;
  }
  pageChange(page: number) {
    this.$store.commit("order/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("order/setPageSize", pagesize);
    this.getpage();
  }
  search() {
    this.$store.commit("order/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.getCourtList();

    if ([4, 5, 6].indexOf(this.pagerequest.orderState) == -1) {
      this.columns[8].title = "订单日期";
    } else {
      this.columns[8].title = "申请退款日期";
    }
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    await this.$store.dispatch({
      type: "order/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.order.pageSize;
  }
  get totalCount() {
    return this.$store.state.order.totalCount;
  }
  get currentPage() {
    return this.$store.state.order.currentPage;
  }
  get orderTypeList() {
    return this.$store.state.common.orderTypes;
  }

  get orderTypeDic() {
    return this.$store.state.common.orderTypesDic;
  }
  get headTypes() {
    return this.$store.state.common.headTypes;
  }
  get orderStates() {
    return this.$store.state.common.orderStates;
  }
  get orderStatesDic() {
    return this.$store.state.common.orderStatesDic;
  }
  get list() {
    const list = this.$store.state.order.list;
    list.forEach((e) => {
      if (e && e.orderState != 1) {
        e["_disabled"] = true;
      }
    });
    return list;
  }
  get loading() {
    return this.$store.state.order.loading;
  }
  getType(type) {
    if (type == 0) {
      return "球场预定";
    } else if (type == 1) {
      return "套餐预定";
    } else if (type == 2) {
      return "二手物品";
    } else if (type == 3) {
      return "套票会籍";
    } else if (type == 4) {
      return "团购订单";
    }
  }
  getSourceType(type) {
    if (type == 0) {
      return "小程序";
    } else if (type == 1) {
      return "Pc";
    } else if (type == 2) {
      return "App";
    } else if (type == 3) {
      return "H5";
    } else if (type == 4) {
      return "其他";
    }
  }
  columns = [
    // {
    //   title: this.L("OrderNum"),
    //   key: "orderNum",
    //   width: 160,
    //   tooltip: true,
    // },
    {
      title: this.L("CourtOrConstituteName"),
      key: "name",
      // width: 160,
      tooltip: false,
    },
    {
      title: "订单类型",
      width: 80,
      render: (h: any, params: any) => {
        return h("span", this.getType(params.row.orderType));
      },
    },
    {
      title: this.L("PlayDate"),
      key: "teeTime",
      width: 80,
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.teeTime).toLocaleDateString());
      },
    },
    {
      title: "打球人员",
      key: "personNames",
    },

    {
      title: this.L("Price"),
      width: 80,
      render: (h: any, params: any) => {
        return h("span", this.L("CurrencyIcon") + " " + params.row.price);
      },
    },
    {
      title: "人数/套数",
      key: "personCount",
      width: 70,
    },
    {
      title: "来源",
      width: 80,
      render: (h: any, params: any) => {
        return h("span", this.getSourceType(params.row.sourceType));
      },
    },
    // {
    //   title: "会员优惠券",
    //   key: "reduction",
    //   width: 70,
    //   render: (h: any, params: any) => {
    //     return h(
    //       "span",
    //       this.L("CurrencyIcon") +
    //         " " +
    //         `${params.row.reduction ? params.row.reduction : "0"}`
    //     );
    //   },
    // },
    // {
    //   title: "vip优惠券",
    //   key: "vipReduction",
    //   width: 70,
    //   render: (h: any, params: any) => {
    //     return h(
    //       "span",
    //       this.L("CurrencyIcon") +
    //         " " +
    //         `${params.row.vipReduction ? params.row.vipReduction : "0"}`
    //     );
    //   },
    // },
    // {
    //   title: "返现金额",
    //   key: "cashback",
    //   width: 70,
    //   render: (h: any, params: any) => {
    //     return h(
    //       "span",
    //       this.L("CurrencyIcon") +
    //         " " +
    //         `${params.row.cashback ? params.row.cashback : "0"}`
    //     );
    //   },
    // },
    {
      title: "订单金额",
      key: "amount",
      width: 70,
      slot: "price",
      // render: (h: any, params: any) => {
      //   return h("span", this.L("CurrencyIcon") + " " + params.row.amount);
      // },
    },
    {
      title: "订单日期",
      key: "creationTime",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          moment(params.row.creationTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("OrderState"),
      slot: "orderState",
      width: 80,
    },
    {
      title: this.L("Actions"),
      slot: "action",
      width: 150,
      align: "center",
    },
  ];
  async created() {
    this.getpage();
    setInterval(() => {
      this.getpage();
      Ajax.get("/api/services/app/Order/GetIsHaveNewOrder").then((res) => {
        if (res && res.data) {
          if (res.data.result == true) {
            var utterThis = new (window as any).SpeechSynthesisUtterance(
              `您有待确认订单未处理！`
            ) as any;
            this.$Message.warning({
              content: "您有待确认订单未处理",
            });
            window.speechSynthesis.speak(utterThis);
          }
        }
      });
    }, 180000);
  }
}
